
import Cookies from 'js-cookie'
/**
 * Functionality to pass on utm params to 1life from cookies
 */
export default class SetUtmParams {
    /**
     * @desc Read UTM cookies, update links to 1life to include the utm values as query params
     *
     */

    constructor() {
        let utmTerms = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']

        let links = this.getOnelifeLinks()
        let query = this.constructQuery(utmTerms)

        if (query.length > 0) {
            this.appendQueryToLinks(links, query)
        }
    }

    getOnelifeLinks() {
        let links = []
        document.querySelectorAll('a').forEach((a) => {
            if (a.href.match(/members.app.onemedical/)) {
                links.push(a)
            } else if (a.href.match(/app.onemedical/)) {
                links.push(a)
            }
        })
        return links
    }

    constructQuery(utmTerms) {
        let query = '', index = 0
        let searchParams = new URL(window.location.href).searchParams

        utmTerms.forEach((term) => {
            // first, check for UTM value in URL parameter
            let utmValue = searchParams.get(term) ?? false

            // second, check for UTM value in cookie
            if (!utmValue) {
                // check cookie exists and value is not set to string "undefined"
                utmValue = Cookies.get(term) ?? false
                utmValue = utmValue === 'undefined' ? false : utmValue
                utmValue = (utmValue && utmValue.length) > 0 ? utmValue : false
            }

            if (utmValue) {
                let queryValue = utmValue.match(/\?/) ? utmValue.split('?')[0] : utmValue
                query += (index++ > 0) ? '&' : '?' // add delimiter
                query += term + '=' + queryValue
            }
        })
        return query.substring(1) // strip the leading '?' if it exists
    }

    appendQueryToLinks(links, query) {
        links.forEach((link) => {
            let glue = link.href.match(/\?/) ? '&' : '?'
            link.href += glue + query
        })
    }
}
